import 'owl.carousel';
import helper from './helpers';
import fancybox from '@fancyapps/fancybox';
function ScrollHeader() {
	var scrollTarget = $('#header'),
		scrollClass = 'fixed-scroll';
	if( helper.isElementScrolledTo(scrollTarget[0].id) ) {
		scrollTarget.addClass(scrollClass);
	} else {
		scrollTarget.removeClass(scrollClass);
	}
}
function triggerLoginForm() {
	var $class = 'active',
		$target = $('#login-form'),
		$login = $('.triggerLoginForm');
	$login.on('click', function() {
		$target.addClass($class);
	});
}
function enableCookiesPolicy() {
	// set cookie policy
	$('#cookie button').on('click', function() {
		helper.setCookie('cookie-accept', true, 365);
		$('#cookie').remove();
	});
}
function triggerSearch() {
	var $class = 'search-active',
		$target = $('#search'),
		$search = $('.triggerSearch');
	$search.on('click', function() {
		$target.toggleClass($class);
		if($target.find('input').val() && $target.hasClass('.' + $class)) {
			$target.find('form')[0].submit();
		}
	});
}
function activateNavMenu() {
	// mobile nav
	$('#nav-menu').on('click', function() {
		var app = $('#app'),
			activeClass = 'menu-active';
		app.addClass(activeClass);
		if(app.hasClass(activeClass)) {
			$('#nav-mask').click(function() {
				app.removeClass(activeClass);
			});
		}
	});
}
function doMobileNav() {
	var nav = $('#nav');
	if(window.innerWidth < 960) {
		nav.find('.menu-item-has-children').hover(function() {
			$(this).children('.sub-menu-wrap').addClass('show');
		}, function() {
			$(this).children('.sub-menu-wrap').removeClass('show');
		});
	}
}
function enableUIToggle() {
	var toggle = $('.ui-toggle');
	toggle.each(function() {
		var load = $(this).data('toggle');
		if(load == 'show') {
			$(this).find('.ui-toggle-content').css("display", "block");
		}
	});
	$('.ui-toggle-title').on('click', function() {
		$(this).next('.ui-toggle-content').toggle();
	});
}
// cookie popups
function enableCookiesPopup() {
	var modal = $('.popup-modal'), btn = modal.find('button'), checkbox = modal.find('.ui-checkbox input');
	checkbox.on('click', function() {
		btn.toggle();
	});
	modal.find('button').on('click', function() {
		var id = modal.attr('id');
		$('#' + id).remove();
		helper.setCookie(id, true, 0.041);
	});
}
// checkbox access
function doCheckboxAccess() {
	$('.ui-checkbox input').on('keypress', function(e) {
		e.preventDefault();
		if(e.keyCode === 13) {
			$(this).prop('checked', !$(this).prop('checked'));
		}
	});
}
// disable user features
function disableUserFeatures() {
	$(document).bind('contextmenu copy paste', function (e) {
		e.preventDefault();
		return false;
	});
}
// toggle filters
function toggleFilters() {
	$('#toggleFilters').on('click', function() {
		$('#filters').toggle();
	});
}
jQuery(document).ready(function($) {
	var env = process.env.NODE_ENV;
	if(env === 'production') {
		// disable end user features
		disableUserFeatures();
	}
	// nav scroll
	ScrollHeader();
	// tabs
	helper.enableTabs();
	// trigger login form
	triggerLoginForm();
	// trigger search
	triggerSearch();
	// activate nav menu
	activateNavMenu();
	// do mobile nav
	doMobileNav();
	// ui select
	helper.enableUISelect();
	// ui toggle
	enableUIToggle();
	// enable cookies policy
	enableCookiesPolicy();
	// cookie popup
	enableCookiesPopup();
	// checkbox access
	doCheckboxAccess();
	// toggle filters
	toggleFilters();
	// fancybox
	$('[data-fancybox]').fancybox({
		closeBtn: true,
		animationEffect: 'fade'
	});
	// on scroll
	$(window).on('scroll', function() {
		// if scroll meets end of page, stop scrolling
		if($(window).scrollTop() + $(window).height() != $(document).height()) {
			ScrollHeader();
		}
		if($(window).scrollTop() > 300) {
			$('#backToTop').show();
		} else {
			$('#backToTop').hide();
		}
	});
	// on resize
	$(window).on('resize', function() {
		doMobileNav();
	});
});